import React, { useState } from 'react'
import { FaPlus } from 'react-icons/fa6'
import PadContainer from '../../../components/PadContainer'
import TitleContainer from '../../../components/TitleContainer'
import { Avatar, Button, Divider, Drawer, Dropdown, Form, Image, Input, Tag } from 'antd'
import { handleConfirm, handleTableSelect, statusType } from '../../../context/utils'
import CustomTable from '../../../components/CustomTable'
import { PiDotsThreeOutlineBold, PiSmileyXEyesFill } from 'react-icons/pi'
import { BiEdit } from 'react-icons/bi'
import { GoTrash } from 'react-icons/go'
import { useDeleteFaq, useGetFaqs, usePatchFaq, usePostFaq } from '../../../hooks/faq/faq'
import { useGetAllBusiness, useGetVendSubHistory, useGetVendor, useGetVendorRatings, usePostBusiness } from '../../../hooks/business/business'
import { CiCalendarDate, CiLocationOn } from 'react-icons/ci'
import { ImStopwatch } from 'react-icons/im'
import moment from 'moment'
import SearchPage from '../../../components/searchPage'
import PaginationPage from '../../../components/paginationPage'

function BusinessTab() {
  const [createPayload, setCreatePayload] = useState({
    title:"",
    content:"",
  })
  const [page, setPage] = useState(0)
  const [search, setSearch] = useState('')
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [isViewOpen, setIsViewOpen] = useState(false)
  const [isName, setName] = useState('')
  const onViewClose = () => setIsViewOpen(false)
  const onViewOpen = () => setIsViewOpen(true)
  const [isViewSubOpen, setIsViewSubOpen] = useState(false)
  const onViewSubClose = () => setIsViewSubOpen(false)
  const onViewSubOpen = () => setIsViewSubOpen(true)
  const [isViewRateOpen, setIsViewRateOpen] = useState(false)
  const onViewRateClose = () => setIsViewRateOpen(false)
  const onViewRateOpen = () => setIsViewRateOpen(true)
  const onCreateOpen = () => setIsCreateOpen(true)
  const [rows, setRows] = useState([])
  const width = window.innerWidth
  const isMobile = width <= 500
  const [form] = Form.useForm()

  const onCreateClose = () => {
    form.resetFields()
    setIsCreateOpen(false)
    setIsOpenEdit(false)
    setRows([])
  }
  
  const {
    data: getData,
    refetch: getFetch,
    isFetching: getLoad,
  } = useGetAllBusiness(
    { pageNumber:page, searchString: search},
    ["pageNumber", "searchString"],
  )

  const {
    data: getVendorData,
    mutate: getVendorAction,
    isLoading: getVendorLoad,
  } = useGetVendor(onViewOpen)

  const {
    data: getRatingData,
    mutate: getRatingAction,
    isLoading: getRatingLoad,
  } = useGetVendorRatings(onViewRateOpen)

  const {
    data: getVenSubHisData,
    mutate: getVenSubHisAction,
    isLoading: getVenSubHisLoad,
  } = useGetVendSubHistory(onViewSubOpen)

  const successAction = () => {
    getFetch()
    form.resetFields();
    onCreateClose()
  };

  const {
    mutate: postAction,
    isLoading: postLoad,
  } = usePostBusiness(successAction)

  const {
    mutate: deleteAction,
    isLoading: deleteLoad,
  } = useDeleteFaq(successAction)

  const {
    mutate: putAction,
    isLoading: putLoad,
  } = usePatchFaq(successAction)

  // const handleEdit = (d) => {
  //     setIsOpenEdit(true)
  //     setCreatePayload({
  //       title:d?.title,
  //       content:d?.content,
  //       id:d?.id
  //     })
  // }

  const handleView = (d) => {
    getVendorAction(d?.userId)
}

const handleSubView = (d) => {
  getVenSubHisAction(d?.id)
  setName(d.businessName)
}

const handleRateView = (d) => {
  getRatingAction(d?.id)
  setName(d.businessName)
}

  const columns = [
    {
      title: "Business Name",
      dataIndex: "businessName",
      key:"1",
      render: (e) => 
        <p className='text-sm font-medium text-dim'>{e || 'Nil'}</p>
    },
    {
      title: "Address",
      dataIndex: "address",
      key:'2',
      render: (e) => 
        <p className='text-sm text-pretty font-medium text-dim'>{e || 'Nil'}</p>
    },
    {
      title: "Opening Days",
      dataIndex: "openingDays",
      key:'2',
      render: (e) => 
        <p className='text-sm text-pretty font-medium text-dim'>{e?.join(", ") || 'Nil'}</p>
    },
    {
      title: "Opening Hour",
      dataIndex: "openingHour",
      key:'2',
      render: (e) => 
        <p className='text-sm font-medium text-dim'>{e || 'Nil'}</p>
    },
    {
      title: "Closing Hour",
      dataIndex: "closingHour",
      key:'2',
      render: (e) => 
        <p className='text-sm font-medium text-dim'>{e || 'Nil'}</p>
    },
    {
      title: "Subscription Status",
      dataIndex: "subscriptionProfile",
      key:'2',
      render: (e) => 
        <Tag color={e?.isExpired ? 'red' : 'blue'}>{e?.isExpired ? 'Expired': 'Active'}</Tag>
    },
    {
      title: "Action",
      dataIndex: "",
      render: (data,idx) => <Dropdown
        key={idx}
        trigger={["click"]}
        placement="bottomLeft"
        menu={{items: [
          {key: "view", icon: <PiSmileyXEyesFill className='!text-base' />, label: <button onClick={()=>handleView(data)}>View Vendor</button>},
          {key: "view", icon: <PiSmileyXEyesFill className='!text-base' />, label: <button onClick={()=>handleSubView(data)}>View Subscription History</button>},
          {key: "view", icon: <PiSmileyXEyesFill className='!text-base' />, label: <button onClick={()=>handleRateView(data)}>View Vendor Ratings</button>},
          // {key: "edit", icon: <BiEdit className='!text-base' />, label: <button onClick={()=>handleEdit(data)}>Edit</button>},
          // {key: "delete", icon: <GoTrash className='!text-base' onClick={() => handleConfirm({data: data?.id, action: deleteAction})} />, label: <button onClick={() => handleConfirm({data: data?.id, action: deleteAction})}>Delete</button>},

        ]}}
      >
        <Button className='!bg-[#F2F6FC]' loading={deleteLoad || getVendorLoad || getVenSubHisLoad || getRatingLoad} type='text' icon={<PiDotsThreeOutlineBold />} />
      </Dropdown>
    },
  ]

  const categories = [
    {
      title: "Name",
      dataIndex: "name",
      key:"name",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e || 'Nil'}</p>
      </div>,
    },
    {
      title: "Image",
      dataIndex: "imageUrl",
      key:"3",
      render: (e) => 
        <Image src={e} alt='vRV' width={80} />
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key:"isActive",
      render: (e) => 
      <Tag className={`{${e} ? ${statusType?.active?.col} : ${statusType?.inactive?.col}} ${e} ? ${statusType?.active?.bd} : ${statusType?.inactive?.bd}} font-bold rounded-2xl px-3 py-0.5`}>{e ? "ACTIVE" : "INACTIVE"}</Tag>
    },
  ]

  const subHistory = [
    {
      title: "Name",
      dataIndex: "name",
      key:"name",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e || 'Nil'}</p>
      </div>,
    },
    {
      title: "Type",
      dataIndex: "type",
      key:"type",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e || 'Nil'}</p>
      </div>,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key:"isActive",
      render: (e) => 
      <Tag className={`{${e} ? ${statusType?.active?.col} : ${statusType?.inactive?.col}} ${e} ? ${statusType?.active?.bd} : ${statusType?.inactive?.bd}} font-bold rounded-2xl px-3 py-0.5`}>{e ? "ACTIVE" : "INACTIVE"}</Tag>
    },
  ]

  
  const rateHistory = [
    {
      title: "Name",
      dataIndex: "name",
      key:"name",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e || 'Nil'}</p>
      </div>,
    },
    {
      title: "Type",
      dataIndex: "type",
      key:"type",
      render: (e) => <div className='flex items-center gap-3'>
        <p className='text-sm font-medium text-dim'>{e || 'Nil'}</p>
      </div>,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key:"isActive",
      render: (e) => 
      <Tag className={`{${e} ? ${statusType?.active?.col} : ${statusType?.inactive?.col}} ${e} ? ${statusType?.active?.bd} : ${statusType?.inactive?.bd}} font-bold rounded-2xl px-3 py-0.5`}>{e ? "ACTIVE" : "INACTIVE"}</Tag>
    },
  ]


  const onSubmit = (d) => {
    postAction(d)
  }
  const onSubmitEdit = () => {
    putAction(createPayload)
  }

  return (
    <PadContainer loading={getLoad}>
      <TitleContainer
        path={false}
        title="Business Management"
        className="border border-lit rounded-xl"
        action={<div className='flex'><SearchPage setSearch={setSearch} size='' /></div>}
      >
        <CustomTable
          pagination={false}
          column={columns}
          data={getData?.data?.data || []}
          rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
        <PaginationPage 
          data={getData}
          setPage={setPage}
        />
      </TitleContainer>


      {/* create create drawer */}
      <Drawer
        open={isCreateOpen}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>New Business</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
        >
          <Form.Item label="Title" name="BusinessName">
            <Input size='large' placeholder='' />
          </Form.Item>
          <Form.Item label="Address" name="Address">
            <Input size='large' placeholder='' />
          </Form.Item>
          <Form.Item label="Title" name="service">
            <Input size='large' placeholder='' />
          </Form.Item>
          <Form.Item label="Title" name="openingDays">
            <Input size='large' placeholder='' />
          </Form.Item>
          <Form.Item label="Title" name="openingHour">
            <Input size='large' placeholder='' />
          </Form.Item>
          <Form.Item label="Title" name="openingTime">
            <Input size='large' placeholder='' />
          </Form.Item>
          <Form.Item label="Description" name="description">
            <Input.TextArea placeholder='Enter description' size='large' rows={4} />
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={postLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      {/* create edit drawer */}
      <Drawer
        open={isOpenEdit}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Edit Subscription</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
        >
          <Form.Item label="Title">
            <Input 
                size='large' 
                placeholder='' 
                value={createPayload.title}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, title: value})}
            />
          </Form.Item>
          <Form.Item label="Content">
            <Input.TextArea 
                placeholder='Enter content' 
                size='large' rows={4} 
                value={createPayload.content}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, content: value})}
            />
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={putLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>
      {/* View Vendor Profile */}
      <Drawer
        open={isViewOpen}
        onClose={onViewClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Vendor Profile</p>}
      >
        <div className='w-full'>
          <div className='grid grid-cols-1 md:grid-cols-3 gap-4 items-center'>
            <Image alt={getVendorData?.data?.businessName || 'Vendor image'} src={getVendorData?.data?.imageUrl} />
            <div className='space-y-3 md:col-span-2'>
              <p className='text-xl font-bold text-light_blue'>Business Name: <br /> <span className='text-2xl'>{getVendorData?.data?.businessName || "NIL"}</span> </p>
              <p className='text-lg font-semibold text-light_blue'>
                Subscription Status:  <br />
                <Tag color={getVendorData?.data?.subscriptionProfile?.isExpired ? 'red':'green'} className='font-bold rounded-2xl px-3 py-0.5'>{getVendorData?.data?.subscriptionProfile?.isExpired ? "Expired":"Active"}</Tag>
              </p>
            </div>
          </div>
          <Divider />
          <div className='w-full px-5 flex justify-between items-center'>
            <div className='w-full rounded-xl bg-[#FEFAF2] px-5 divide-y'>
              <p className='text-lg text-light_blue font-bold'>Services:</p>
              <p className='text-lg text-light_blue font-semibold'>
                {getVendorData?.data?.services?.join(",  ")}
              </p>
            </div>
          </div>
          <Divider />
          <div className='w-full rounded-xl bg-[#FEFAF2] px-5 divide-y'>
            {[
              {Icon: CiLocationOn, title: 'Address', value: (getVendorData?.data?.address || "NIL")},
              {Icon: CiCalendarDate, title: 'Opening Days', value: (getVendorData?.data?.openingDays?.join(", ") || "NIL")},
              {Icon: ImStopwatch, title: 'Opening Hour', value: (getVendorData?.data?.openingHour)},
              {Icon: ImStopwatch, title: 'Closing Hour', value: (getVendorData?.data?.closingHour)},
            ].map(({Icon, title, value}) => (
              <div className='flex items-center gap-3 py-5'>
                <p className='text-lg font-bold text-silver'>{title}:</p>
                <Button className='!bg-[#FDE9C2] !text-[#F5A302]' icon={<Icon className="!text-xl" />} shape='circle' size='large' type='primary' />
                <p className='text-lg font-semibold text-silver'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            <TitleContainer
              path={false}
              title="Categories"
              className="border border-lit rounded-xl"
            >
              <CustomTable
                pagination={false}
                column={categories}
                data={getVendorData?.data?.categories || []}
              />
            </TitleContainer>
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            <p className='text-base text-light_blue font-semibold'>Description</p>
            <p className='text-sm text-dim font-normal'>{getVendorData?.data?.description || "NIL"}</p>
          </div>
          <Divider />
          <div className='grid gap-5'>
            {/* <Button onClick={handleEdit} id={getVendorData?.data?.id} loading={false} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Edit</Button> */}
            <Button loading={getVenSubHisLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary' onClick={()=>handleSubView(getVendorData?.data)}>View Subscription History</Button>
          </div>
        </div>
      </Drawer>
      {/* View Subscription History */}
      <Drawer
        open={isViewSubOpen}
        onClose={onViewSubClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>{isName}</p>}
      >
        <div className='w-full'>
          <div className='w-full px-2 space-y-1'>
            <TitleContainer
              path={false}
              title="Subscription History"
              className="border border-lit rounded-xl"
            >
              <CustomTable
                pagination={false}
                column={subHistory}
                data={getVenSubHisData?.data?.data || []}
              />
            </TitleContainer>
          </div>
        </div>
      </Drawer>
      {/* View Vendor Ratings */}
      <Drawer
        open={isViewRateOpen}
        onClose={onViewRateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>{isName}</p>}
      >
        <div className='w-full'>
          <div className='w-full px-2 space-y-1'>
            <TitleContainer
              path={false}
              title=" Vendor Ratings"
              className="border border-lit rounded-xl"
            >
              <CustomTable
                pagination={false}
                column={rateHistory}
                data={getRatingData?.data?.data || []}
              />
            </TitleContainer>
          </div>
        </div>
      </Drawer>
    </PadContainer>
  )
}

export default BusinessTab